import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Invite a connection to iknowa platform", -1)
const _hoisted_3 = { class: "modal__content" }
const _hoisted_4 = { class: "modal__inner__content" }
const _hoisted_5 = { class: "input_field email_address" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Email Addresses", -1)
const _hoisted_7 = { class: "input_field email_address" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Invite As", -1)
const _hoisted_9 = { class: "input_field tags_wrapper" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Tags", -1)
const _hoisted_11 = { class: "input_field email_address" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Property", -1)
const _hoisted_13 = { class: "input_field message_wrapper" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Message (optional):", -1)
const _hoisted_15 = { class: "modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvitationSuccessComponent = _resolveComponent("InvitationSuccessComponent")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return ($setup.isShowInvitationsSentModal)
    ? (_openBlock(), _createBlock(_component_InvitationSuccessComponent, {
        key: 0,
        onOnClose: $setup.onClickCloseButton,
        members: $setup.form.members
      }, null, 8, ["onOnClose", "members"]))
    : (_openBlock(), _createBlock(_component_CommonDialog, {
        key: 1,
        isShowHeader: false,
        isShowBackButton: false,
        className: ['add_contractor_dialog'],
        width: "968px"
      }, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_v_btn, {
              icon: "mdi-close",
              onClick: $setup.onClickCloseButton
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_form, {
                ref: "emailFormRef",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                class: "tw-w-full"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.members, (member, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "tw-w-full invite_members_form"
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createVNode(_component_v_text_field, {
                          type: "email",
                          density: "compact",
                          modelValue: member.email,
                          "onUpdate:modelValue": ($event: any) => ((member.email) = $event),
                          rules: $setup.validation.email,
                          variant: "outlined",
                          class: "c-input",
                          placeholder: "Email address"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createVNode(_component_v_select, {
                          class: "c-select",
                          modelValue: member.inviteAs,
                          "onUpdate:modelValue": ($event: any) => ((member.inviteAs) = $event),
                          items: $setup.inviteAsType,
                          rules: $setup.validation.inviteAs,
                          placeholder: "Select Role",
                          variant: "outlined"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_v_select, {
                          class: "c-select",
                          modelValue: member.tags,
                          "onUpdate:modelValue": ($event: any) => ((member.tags) = $event),
                          items: $setup.Tags,
                          rules: $setup.validation.tags,
                          "error-messages": $setup.IsValidTag(member),
                          placeholder: "Select Tags",
                          multiple: "",
                          variant: "outlined",
                          "menu-props": { contentClass: 'tags_dropdown' }
                        }, {
                          "prepend-item": _withCtx(() => [
                            _createVNode(_component_v_list_item, {
                              title: "Select All",
                              onClick: ($event: any) => ($setup.toggle(member)),
                              class: "list__item"
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_checkbox_btn, {
                                  color: 
                            $setup.likesSomeTag(member) ? 'indigo-darken-4' : undefined
                          ,
                                  indeterminate: 
                            $setup.likesSomeTag(member) && !$setup.likesAllTags(member)
                          ,
                                  "model-value": $setup.likesAllTags(member)
                                }, null, 8, ["color", "indeterminate", "model-value"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          "append-item": _withCtx(() => [
                            _createVNode(_component_v_list_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: $setup.customTag,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.customTag) = $event)),
                                  label: "Add custom tag",
                                  variant: "outlined",
                                  class: "inner_input"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_btn, {
                                  onClick: ($event: any) => ($setup.addCustomTag(member)),
                                  class: "button button-orange"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Add")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "items", "rules", "error-messages"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode(_component_v_select, {
                          class: "c-select",
                          modelValue: member.propertyIds,
                          "onUpdate:modelValue": ($event: any) => ((member.propertyIds) = $event),
                          items: $setup.propertyList,
                          "item-title": "address",
                          "item-value": "id",
                          rules: $setup.validation.propertyIds,
                          placeholder: "Select Property",
                          variant: "outlined",
                          multiple: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"])
                      ]),
                      ($setup.form.members.length > 1)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            icon: "mdi-close",
                            onClick: ($event: any) => ($setup.onRemoveEmail(index)),
                            class: "remove_btn",
                            variant: "plain"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _createVNode(_component_Button, {
                    variant: "accent",
                    class: "button add_btn",
                    onClick: $setup.onAddEmail,
                    label: "+ADD"
                  }, null, 8, ["onClick"]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_v_textarea, {
                      modelValue: $setup.memberMessage,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.memberMessage) = $event)),
                      variant: "outlined"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }, 512)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_Button, {
              variant: "secondary",
              label: "CANCEL",
              class: "button !tw-max-w-[max-content]",
              onClick: $setup.onClickCloseButton
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              label: "SEND INVITATION",
              class: "button !tw-max-w-[max-content]",
              variant: "accent",
              onClick: $setup.onSendInvitation,
              isLoading: $setup.isShowLoadingSendInvitation,
              isActive: $setup.isFormValid && $setup.hasAtLeastOneMember
            }, null, 8, ["onClick", "isLoading", "isActive"])
          ])
        ]),
        _: 1
      }))
}